import { ArrowRightIcon } from "@heroicons/react/24/outline"
import useInView from "@hooks/useInView"
import { useTranslation } from "react-i18next"

const METRICS = [
  { after: 90, before: 30, key: "retention" },
  { after: 85, before: 35, key: "focus" },
  { after: 95, before: 25, key: "clarity" },
]

function MetricBar({
  color,
  delayMs,
  isVisible,
  value,
}: {
  color: string
  delayMs: number
  isVisible: boolean
  value: number
}) {
  return (
    <div className="h-2 w-full overflow-hidden rounded-full bg-vm-line">
      <div
        className={`h-full rounded-full transition-[width] duration-1000 ease-out ${color}`}
        style={{
          transitionDelay: `${delayMs}ms`,
          width: isVisible ? `${value}%` : "0%",
        }}
      />
    </div>
  )
}

export default function BeforeAfter() {
  const [ref, isInView] = useInView<HTMLDivElement>()
  const { t } = useTranslation()

  return (
    <div className="vm-card overflow-hidden" ref={ref}>
      <div className="grid grid-cols-[1fr_auto_1fr] items-center border-b border-vm-line bg-vm-cream/60 px-4 py-3 text-center text-sm font-bold">
        <span className="text-vm-red-text">
          {t("pages.checkout.paywall.beforeAfter.now")}
        </span>
        <ArrowRightIcon className="h-4 w-4 text-vm-muted" />
        <span className="text-vm-green-text">
          {t("pages.checkout.paywall.beforeAfter.withVisualMind")}
        </span>
      </div>

      <div className="space-y-4 p-4">
        <div className="grid grid-cols-2 gap-x-6">
          <span className="text-center text-5xl">😵‍💫</span>
          <span className="animate-float text-center text-5xl">🤩</span>
        </div>

        {METRICS.map((metric, index) => (
          <div className="space-y-1.5" key={metric.key}>
            <p className="text-center text-xs font-medium text-vm-muted">
              {t(`pages.checkout.paywall.beforeAfter.metrics.${metric.key}`)}
            </p>
            <div className="grid grid-cols-2 gap-x-6">
              <MetricBar
                color="bg-vm-red"
                delayMs={index * 150}
                isVisible={isInView}
                value={metric.before}
              />
              <MetricBar
                color="bg-vm-green"
                delayMs={index * 150}
                isVisible={isInView}
                value={metric.after}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
